import { InfoOutlined  } from "@mui/icons-material";
import { Box, IconButton, Tooltip } from "@mui/material";
import AppTable from "components/Shared/AppTable";
import TableFilter from "components/Shared/AppTable/TableFilter";
import HighlightedText from "components/Shared/HighlightedText";
import { useTablePagination } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLazyGetVendorListDataQuery } from "store/services/CanUsers/vendorApi";

const VendorListScreen = () => {
  const { currentPage, perPage, handlePageChange, handlePerRowsChange } =
    useTablePagination();
  const [searchParams] = useSearchParams();

  const keyword = searchParams.get("search") || "";

  const breadcrumbs = [
    {
      title: "Vendor",
    },
  ];

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      cell: (row) => (
        <Link
          title={row?.name}
          to={`/app/crm/vendor/${row._id}/detail`}
          className="line-clamp-2 hover:text-blue-600 hover:underline dark:hover:text-blue-300"
        >
          {row?.name ? (
            <HighlightedText text={row?.name} highlight={keyword} />
          ) : (
            "N/A"
          )}
        </Link>
      ),
      minWidth: "250px",
      sortable: true,
    },

    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: "Type",
      selector: (row) => row.type,
      sortable: true,
    },
    {
      name: "Controlling User",
      selector: (row) => row.controllingUserDetails?.name,
      cell: (row) => (
        <Box display="flex" justifyContent="center" alignItems="center" width="100%">
          <Link
            title={row?.controllingUserDetails?.name}
            to={`/app/crm/user/${row?.controllingUser}/detail`}
            className="line-clamp-2 hover:text-blue-600 hover:underline dark:hover:text-blue-300"
          >
            {row?.controllingUserDetails?.name ? (
              <HighlightedText text={row?.controllingUserDetails?.name} highlight={keyword} />
            ) : (
              "N/A"
            )}
          </Link>
        </Box>
      ),
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex items-center gap-1">
          <Link to={`/app/crm/vendor/${row._id}/detail`}>
            <Tooltip title={"View Vendor Detail"} arrow>
              <IconButton size="small" aria-label="View vendor" color="primary">
                <InfoOutlined />
              </IconButton>
            </Tooltip>
          </Link>
          {/* <Link to={`/app/crm/vendor/${row._id}/edit`} state={{ from: "list" }}>
            <Tooltip title={"Edit Vendor"} arrow>
              <IconButton size="small" aria-label="Edit vendor">
                <ModeEditOutlineTwoTone />
              </IconButton>
            </Tooltip>
          </Link> */}
        </div>
      ),
      ignoreRowClick: true,
      right: true,
    },
  ];

  // RTK Query
  const [
    fetchVendors,
    {
      data: vendorRes,
      isLoading: loadingVendors,
      isFetching: fetchingVendors,
      error,
    },
  ] = useLazyGetVendorListDataQuery();

  React.useEffect(() => {
    fetchVendors({
      page: currentPage,
      limit: perPage,
      ...(keyword && { search: keyword }),
    });
  }, [currentPage, fetchVendors, keyword, perPage]);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} headerActions={<PageActions />}>
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <TableFilter
          searchLabel="Name"
          disabled={loadingVendors || fetchingVendors}
        >
          <div className="font-medium"> Vendors </div>
        </TableFilter>

        <AppTable
          columns={columns}
          data={vendorRes?.data ?? []}
          progressPending={loadingVendors || fetchingVendors}
          paginationServer
          paginationPerPage={perPage}
          paginationTotalRows={vendorRes?.totalItems ?? 0}
          paginationDefaultPage={currentPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default VendorListScreen;

const PageActions = () => {
  return (
   <>
    {/* <Link to="/app/crm/vendor/create">
      <Button startIcon={<Add />} variant="contained">
        New Vendor
      </Button>
    </Link> */}
   </>
  );
};
